query getGeneratedImages($input: GetGeneratedImagesInput!) {
  generatedImages: getGeneratedImages(input: $input) {
    images {
      id
      fileId
      url
      originalImageUrl
      history {
        id
        type
        timestamp
        userId
      }
    }
    total
    page
    perPage
  }
}
